<template>
    <div>
        <v-tabs-items v-model="tab">
            <v-tab-item
                v-for="itemTabsItem in Object.keys(items)"
                :key="itemTabsItem"
                :transition="false"
            >
                <v-data-table
                    dense
                    :headers="headers"
                    :items="filteredItems(itemTabsItem)"
                    class="signEndConTbl"
                    :loading="loading.signed ? 'teal darken-1' : null"
                >
                    <template #top>
                        <slot name="backBtn"></slot>
                        <v-tabs
                            v-model="tab"
                            align-with-title
                        >
                            <v-tabs-slider color="teal darken-1" />
                            <v-tab
                                v-for="itemTabs in Object.keys(items)"
                                :key="itemTabs"
                                style="width: 150px;"
                            >
                                <v-badge :color="itemTabs==='signed' ? 'success' : 'error'">
                                    {{ itemTabs }}<template #badge>
                                        {{ items[itemTabs].length }}
                                    </template>
                                </v-badge>
                            </v-tab>
                        </v-tabs>
                    </template>
                    <template #item="{ item, index }">
                        <tr
                            @mouseenter="hoveredRow = index"
                            @mouseleave="hoveredRow = null"
                        >
                            <td
                                v-for="header in headers"
                                :key="header.value"
                                :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: ['TYPE', 'ACTION', 'SIGNED', 'SIGNED ON'].includes(header.value) ? 'center' : '' }"
                            >
                                <span style="text-wrap: nowrap;">
                                    <template v-if="header.value === 'SIGNED ON' || header.value === 'PREPARED ON'">
                                        {{ item[header.value] !== null ? formatDateToPst(item[header.value]) : '-' }}
                                    </template>
                                    <template v-else-if="header.value === 'SIGNED'">
                                        <v-icon
                                            v-if="!item.SIGNED"
                                            color="error"
                                        >{{ mdiCloseCircle }}</v-icon>
                                        <v-icon
                                            v-else
                                            color="success"
                                        >{{ mdiCheckCircle }}</v-icon>
                                    </template>
                                    <template v-else-if="header.value === 'ACTION'">
                                        <div style="width: 100%; min-width: 100px;">
                                            <v-tooltip top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        class="white--text"
                                                        color="teal darken-1"
                                                        style="min-width: 0; width: 10px; padding: 17px 21px;"
                                                        :loading="loading.view && loading.data === item.ID"
                                                        v-on="on"
                                                        @click="handleViewFile(item.ID)"
                                                    ><v-icon>{{ mdiEye }}</v-icon></v-btn>
                                                </template>
                                                <span>View</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        class="white--text"
                                                        color="error"
                                                        style="min-width: 0; width: 10px; padding: 17px 21px; margin-left: 5px;"
                                                        v-on="on"
                                                        @click="handleDeleteFile(item)"
                                                    ><v-icon>{{ mdiTrashCan }}</v-icon></v-btn>
                                                </template>
                                                <span>Delete</span>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ item[header.value] }}
                                    </template>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-tab-item>
        </v-tabs-items>
        <PdfViewer
            :data="showPdf.data"
            :show="showPdf.show"
            :showing-id="showingId"
            :screen_width="screen_width"
            :notif="notif"
            @reopenPdfViewer="showPdf.reopen = true"
            @closePdfViewer="showPdf.show = false"
        />
        <ConfirmDelete
            :data="showDelete.data"
            :show="showDelete.show"
            :notif="notif"
            @closeDialog="showDelete.show = false"
        />
    </div>
</template>

<script>
import { moment } from '../../../../../../utils/date-shim'
import { mapGetters, mapActions } from 'vuex'
import PdfViewer from './PdfViewer.vue'
import ConfirmDelete from './ConfirmDelete.vue'
import {
    mdiCloseCircle,
    mdiCheckCircle,
    mdiEye,
    mdiTrashCan
} from '@mdi/js'

export default {
    components: { PdfViewer, ConfirmDelete },
    props: ['notif', 'screen_width', 'search', 'sign', 'loading'],
    data: ()=>({
        mdiCloseCircle,
        mdiCheckCircle,
        mdiEye,
        mdiTrashCan,
        dataItems: [],
        tab: 0,
        items: {
            signed: [],
            unsigned: []
        },
        showingId: null,
        showPdf: {
            show: false,
            data: null,
            reopen: false
        },
        showDelete: {
            show: false,
            data: null
        },
        hoveredRow: null,
        headers: [
            { text: 'ID', value: 'ID' },
            { text: 'ACCOUNT NO.', value: 'ACCOUNT NO.', align: 'center' },
            { text: 'ACCOUNT NAME', value: 'ACCOUNT NAME' },
            { text: 'MSU CODE', value: 'MSU CODE' },
            { text: 'ACCOUNT CLINIC', value: 'ACCOUNT CLINIC' },
            { text: 'TYPE', value: 'TYPE', align: 'center' },
            { text: 'SIGNED', value: 'SIGNED' },
            { text: 'SIGNED BY', value: 'SIGNED BY' },
            { text: 'SIGNED ON', value: 'SIGNED ON', align: 'center' },
            { text: 'PREPARED BY', value: 'PREPARED BY' },
            { text: 'PREPARED ON', value: 'PREPARED ON' },
            { text: 'ACTION', value: 'ACTION', sortable: false, align: 'center' }
        ]
    }),
    computed: {
        ...mapGetters(['listEndorsementConfirmationData', 'signEndorsementConfirmationData', 'viewEndorsementConfirmationData'])
    },
    watch: {
        listEndorsementConfirmationData(newVal) {
            if (newVal && newVal.data) {
                this.dataItems = newVal.data ? newVal.data : []
                const arr = newVal.data
                this.items.signed = []
                this.items.unsigned = []
                for (let i=0; i<arr.length; i++) {
                    if (arr[i].SIGNED) {
                        this.items.signed.push(arr[i])
                    } else {
                        this.items.unsigned.push(arr[i])
                    }
                }
            }
            this.loading.signed = false
        },
        'sign.status'(newVal) {
            if (newVal) {
                this.loading.signed = true
                this.listEndorsementConfirmation()
                this.$emit('changeStatSign')
            }
        },
        'showPdf.reopen'(newVal) {
            if (newVal) {
                this.showPdf.show = false
                this.handleViewFile(this.showingId)
                this.$nextTick(()=>{
                    this.showPdf.reopen = false
                })
            }
        },
        viewEndorsementConfirmationData(newVal) {
            const isFetchSuccess = newVal && newVal.status === 200
            if (!isFetchSuccess) {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
            } else {
                this.showPdf.show = true
                this.showPdf.data = newVal.data
            }
            this.loading.view = false
        }
    },
    methods: {
        ...mapActions(['signEndorsementConfirmation', 'listEndorsementConfirmation', 'viewEndorsementConfirmation']),
        filteredItems(tabKey) {
            const items = this.items[tabKey] || []
            const search = this.search.value

            if (!search) return items

            const keyword = search.toString().toLowerCase()

            return items.filter(item =>
                (item.ID && item.ID.toString() === keyword) ||
                (item['ACCOUNT NO.'] && item['ACCOUNT NO.'].toString() === keyword) ||
                (item['ACCOUNT NAME'] && item['ACCOUNT NAME'].toLowerCase().includes(keyword)) ||
                (item['MSU CODE'] && item['MSU CODE'].toString() === keyword) ||
                (item['ACCOUNT CLINIC'] && item['ACCOUNT CLINIC'].toLowerCase().includes(keyword)) ||
                (item.TYPE && item.TYPE.toLowerCase().includes(keyword)) ||
                (item['SIGNED BY'] && item['SIGNED BY'].toLowerCase().includes(keyword)) ||
                (item['SIGNED ON'] && this.formatDateToPstDateOnly(item['SIGNED ON']) == this.formatDateToPstDateOnly(keyword)) ||
                (item['PREPARED BY'] && item['PREPARED BY'].toLowerCase().includes(keyword)) ||
                (item['PREPARED ON'] && this.formatDateToPstDateOnly(item['PREPARED ON']) == this.formatDateToPstDateOnly(keyword)) ||
                (
                    item.ACU_MEMBERS &&
                    Array.isArray(item.ACU_MEMBERS) &&
                    item.ACU_MEMBERS.some(member =>
                        member.MEMB_N &&
                        member.MEMB_N.toString() === keyword
                    )
                )
            )
        },
        handleDeleteFile(item) {
            this.showDelete.data = item
            this.showDelete.show = true
        },
        handleViewFile(ID) {
            this.loading.data = ID
            this.loading.view = true
            this.showingId = ID
            this.viewEndorsementConfirmation({ ID })
        },
        formatDateToPst(date) {
            if (date) {
                return moment(date).utcOffset('+0800').format('MMMM DD, YYYY hh:mm A')
            } else {
                return '-'
            }
        },
        formatDateToPstDateOnly(date) {
            if (date) {
                return moment(date).utcOffset('+0800').format('MMMM DD, YYYY')
            } else {
                return '-'
            }
        }
    }
}
</script>

<style>
.signEndConTbl > div > table > thead > tr > th {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    z-index: 2; /* Ensure the second column has a lower z-index than the first one */
    background: white;
    top: 0;
}
.signEndConTbl > div > table > tbody > tr > td:last-child {
    width: 80px; /* You can adjust this width as needed */
    position: sticky !important;
    padding: 0;
    right: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: pink;
}
.signEndConTbl > div > table > thead > tr > th:last-child {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    right: 0;
    z-index: 5; /* Ensure the first column has a higher z-index */
    background: white;
}
.signEndConTbl .v-data-table__wrapper {
    max-height: 70vh; /* Adjust the height according to your needs */
    overflow-y: auto; /* Enable vertical scrolling */
}
</style>
